import { format } from 'owa-localize';

import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import { createRemoveRecipientLink } from './createRemoveRecipientLinks';
import RemoveMultiRecipientMailtip from '../components/RemoveMultiRecipientMailtip';
import * as React from 'react';
import { MessagePart } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import { MailTipsCategory } from '../datapoints';

/**
 * @param recipient
 * @param str
 * @param onRemoveRecipientsClick
 * returns a formatted string and remove link for a single recipient
 */
export const getMessagePartsForSingleRecipient = (
    recipient: EmailAddressWrapper,
    str: string,
    onRemoveRecipientsClick: (recipients: EmailAddressWrapper[]) => void,
    mailTipsCategory?: MailTipsCategory
) => [
    format(str, recipient.Name),
    createRemoveRecipientLink(recipient, onRemoveRecipientsClick, mailTipsCategory),
];

/**
 * @param recipients
 * @param singleRecipientStr
 * @param multiRecipientStr
 * @param onRemoveRecipientsClick
 * returns messageParts in case of 1 recipient with messageElement as null.
 * returns messageElement for more than 1 recipients with messageParts as null.
 */
export const getGenericMessageElementAndParts = (
    recipients: EmailAddressWrapper[],
    singleRecipientStr: string,
    multiRecipientStr: string,
    onRemoveRecipientsClick: (recipients: EmailAddressWrapper[]) => void,
    mailTipsCategory?: MailTipsCategory
): [JSX.Element, MessagePart[]] => {
    const messageParts =
        recipients.length === 1
            ? getMessagePartsForSingleRecipient(
                  recipients[0],
                  singleRecipientStr,
                  onRemoveRecipientsClick,
                  mailTipsCategory
              )
            : null;

    const messageElement = messageParts ? null : (
        <RemoveMultiRecipientMailtip
            messageInfoText={format(multiRecipientStr, recipients.length)}
            recipientEmails={recipients}
            onRemove={onRemoveRecipientsClick}
            mailTipsCategory={mailTipsCategory}
        />
    );

    return [messageElement, messageParts];
};
